import * as t from 'io-ts';
import { id } from '@/services/api';
import { subscriptionCodec } from '@/services/api/resources/subscription/codec';
import { withFallback } from 'io-ts-types/withFallback';
import { DateFromUnixTime } from 'io-ts-types/DateFromUnixTime';

export const organizationCodec = t.type({
  id,
  title: t.string,
  formConverted: t.boolean,
  subscription: t.union([t.null, subscriptionCodec]),
  paysByInvoice: t.boolean,
  trialStatus: t.string,
  usersCount: t.union([t.undefined, t.number]),
  hasPaymentMethod: t.boolean,
  preferredCurrency: t.string,
  forceCurrency: t.boolean,
  reportLowQualityImagesEnabled: withFallback(t.boolean, false),
  onboardingFinished: withFallback(t.boolean, false),
  onboardingViewed: withFallback(t.boolean, false),
  firstLoginViewed: withFallback(t.boolean, false),
  smsServiceEnabled: withFallback(t.boolean, false),
  firstUserId: withFallback(t.number, 0),
  createdAt: DateFromUnixTime,
  appliedForDiscount: withFallback(t.boolean, false),
  canSelfServeSubscription: withFallback(t.boolean, false),
  addons: t.type({
    approvalsEnabled: withFallback(t.boolean, false),
    publicApiEnabled: withFallback(t.boolean, false),
    ssoEnabled: withFallback(t.boolean, false),
    formTranslationsEnabled: withFallback(t.boolean, false),
    manualFormTranslationsEnabled: withFallback(t.boolean, false),
    aiImageDescriptionEnabled: withFallback(t.boolean, false),
    trainingsModuleEnabled: withFallback(t.boolean, false),
  }),
});

export const organizationLanguagesCodec = t.type({
  data: t.array(t.string),
});

export const organizationApiKeyCodec = t.type({
  organizationId: t.number,
  apiKey: t.string,
});

export const organizationSecretApiKeyCodec = t.type({
  apiKey: t.string,
  apiSecret: t.string,
});

export const organizationApiKeyResponseCodec = t.type({
  data: organizationApiKeyCodec,
});

export const organizationSecretApiKeyResponseCodec = t.type({
  data: organizationSecretApiKeyCodec,
});
